import moment from "moment-jalaali"
import { WEB_PUSH_SUBSCRIBED_TIME } from "constants/storages"

export async function handleOnSubscribePushNotificationQueryStarted({ dispatch, queryFulfilled, getState }: any) {
  try {
    await queryFulfilled
    const todayDate = moment(new Date()).toDate()
    localStorage.setItem(WEB_PUSH_SUBSCRIBED_TIME, todayDate.toString())
  } catch (error) {
    console.error(`Error subscribing push notification:`, error)
  }
}
